<template>
  <v-card v-if="cashInMethod">
    <slot name="title">
      <v-toolbar color="grey lighten-4" light tile flat>
        <v-toolbar-title centered class="headline font-weight-bold">{{ title }}</v-toolbar-title>
        <div class="flex-grow-1"></div>

        <v-spacer></v-spacer>
        <v-btn color="primary" @click="isUpdating = true">
          <v-icon>mdi-pencil</v-icon>
          Edit
        </v-btn>
      </v-toolbar>
    </slot>

    <v-card-text>
      <v-row>
        <v-col cols="4">
          <key-value title="Id">
            <span class="small" v-text="cashInMethod.id"></span>
          </key-value>
          <key-value title="Payment Method Name" :value="cashInMethod.name" />
          <key-value title="Type" :value="cashInMethod.payment_type.name" />
          <key-value title="Provider" :value="cashInMethod.payment_provider.name" />
        </v-col>
        <v-col cols="4">
          <key-value title="Min Amount (€)" :value="cashInMethod.min_amount" type="date" />
          <key-value title="Max Amount (€)" :value="cashInMethod.max_amount" type="date" />
        </v-col>
        <v-col cols="4">
          <key-value title="Apps">
            <ul>
              <li v-for="app in cashInMethod.apps" :key="app">
                {{ app }}
              </li>
            </ul>
          </key-value>
        </v-col>
      </v-row>
    </v-card-text>
    <update-cash-in-method-form
      method="put"
      :cashInMethod="cashInMethod"
      :is-active.sync="isUpdating"
      @changed="cashInMethodUpdated"
    ></update-cash-in-method-form>
  </v-card>
</template>

<script>
import UpdateCashInMethodForm from "./form";

export default {
  props: {
    dataCashInMethod: Object,
    title: { default: "Transfer CashIn Method Details" },
    hideActions: { type: Boolean, default: false },
  },
  components: { UpdateCashInMethodForm },
  data() {
    return {
      isUpdating: false,
      cashInMethod: this.dataCashInMethod,
    };
  },
  computed: {},
  methods: {
    cashInMethodUpdated({ cashInMethod }) {
      this.cashInMethod = cashInMethod;
      this.$emit("updated", cashInMethod);
      this.isUpdating = false;
    },
  },
};
</script>
